import { LMS_CONSTANTS } from "@ipru-common/constants/SiteConstants";
import { OPTION_VALUES } from "@ipru-common/constants/InputValues";
import { getSelectedFunds } from "@ipru-common/utils/CommonFunctions";
import { calculateAnnualPremium, calculateSAMultiple } from "@ipru-common/utils/SmartKidQuote/commonUtils";
import { getAge } from "@ipru-common/libs/ValidationSchemas/CustomRules";
import GlobalStore from "@ipru-common/store/GlobalStore";
import { mapDataToSuitabilityData as mapToSuitabilityData } from "../../components/CommonComponents/SuitabilityCalModal/SuitabilityMapper";
import CommonKeys from "./CommonUserInput";

export const getSmartKidUserInput = () => {
  const { appFormData, quoteFormData, calculatorFormData, savingForm, existingCustomer } = GlobalStore.getSnapshot();
  const suitabilityData = mapToSuitabilityData(calculatorFormData, quoteFormData);
  const annualPremium = calculateAnnualPremium({
    invest: quoteFormData?.invest,
    paymentFrequency: quoteFormData?.paymentFrequency,
  });
  const totalPremium = annualPremium * quoteFormData?.ppt;
  let smartkidUserInput = {
    cdob: calculatorFormData?.child_dob,
    cage: calculatorFormData?.child_dob && getAge(calculatorFormData?.child_dob),
    name: calculatorFormData?.child_name,
    crelation: appFormData?.personalDetails?.nominee_relationship,
    cgender: appFormData?.personalDetails?.nominee_gender,
    appointeeGender: appFormData?.personalDetails?.appointee_gender,
    appointeeRelation: appFormData?.personalDetails?.appointee_relationship,
    trai: calculatorFormData?.trai_flag,
    suitCheckbox: suitabilityData?.skip_suitability_check,
    paymentOption: OPTION_VALUES.PAYMENT_OPTIONS[quoteFormData?.paymentOption],
    payout: LMS_CONSTANTS[quoteFormData?.payoutType],
    ppt: quoteFormData?.ppt,
    onlinebenefit: 0,
    saMultiple:
      quoteFormData?.ppt && calculatorFormData?.age
        ? calculateSAMultiple({
            PremiumPaymentTerm: quoteFormData?.ppt || 0,
            age: calculatorFormData?.age,
          })
        : 0,
    whole_life: suitabilityData?.whole_life,
    relation: suitabilityData?.relation,
    premium: totalPremium,
    mode: suitabilityData?.mode,
    lifeCover: quoteFormData?.lifeCover,
    adbr: suitabilityData?.adbr,
    productId: calculatorFormData?.productCode,
    invest_type: suitabilityData?.invest_type,
    invest_strat: suitabilityData?.invest_strat,
    OutputObjHold_4: suitabilityData?.OutputObjHold_4,
    OutputObjHold_8: suitabilityData?.OutputObjHold_8,
    SavingsPercentage: suitabilityData?.pastPerformancePercent,
    funds: suitabilityData?.funds,
    swp: suitabilityData?.swp,
    ats: suitabilityData?.ats,
    fundCat: suitabilityData?.fundCat,
    calcType: suitabilityData?.calcType,
    selectedFunds: quoteFormData?.allocatedFunds ? getSelectedFunds(quoteFormData?.allocatedFunds) : 0,
    isDefaultPastRequired: true,
    payFor: quoteFormData?.payFor,
    paymentFreq: LMS_CONSTANTS[quoteFormData?.tenure],
    Step: `step${savingForm?.currentStep}`,
  };

  return { ...CommonKeys(calculatorFormData, existingCustomer, quoteFormData), ...smartkidUserInput };
};

export default getSmartKidUserInput;
